var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "breadcrumb" },
    _vm._l(_vm.links, function (link, index) {
      return _c("breadcrumb-item", {
        key: index,
        attrs: {
          label: link.label,
          href: link.href,
          "is-first": !index,
          "is-active": link.isActive,
        },
        on: { "active-route-changed": _vm.onActiveRouteChanged },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }